export default __webpack_public_path__ + "favicon-16x16.ae293c8b.png";